import { useDispatch, useSelector } from "react-redux";
import defaultAvathar from "../../../src/assets/images/default-avatar.jpg"
import { Popover } from "antd";
import { useCallback, useState } from "react";
import { Link } from "react-router-dom";
import { userManager } from 'src/authentication';
import { clearProfile } from 'src/reducers/authReducer';
const Profile = () => {
    const dispatch=useDispatch()
    const [visible, setVisible] = useState(false);
    const adminDetails = useSelector(state => state.oidc?.adminDetails?.currentUser)
    const adminProfileImg = useSelector(state => state.oidc?.adminProfileImg);
    const handleLogout = () => {
        dispatch(clearProfile())
        userManager.signoutRedirect();
      }
    const visiableChangeHandler=useCallback((v)=>{
        setVisible(v)
    },[])
    const closePopupHandler=useCallback(()=>{
        setVisible(false)
    },[])
    const profileMenuHandler = useCallback(() => {
        return (
            <div className="w-64 md:w-60 !bg-transparent mb-2">
            <div className='text-start flex items-center gap-2 mb-2'>
                <div> <img className='w-12 h-12 rounded-full object-cover border border-headerbborder m-auto' src={adminProfileImg || adminDetails?.imageURL || defaultAvathar} alt="profile img" /></div>
                <div className="">
                  <p className="text-base font-semibold text-subTextColor block break-words capitalize md:w-[186px]">{adminDetails?.userName}</p>
                  <p className='text-subTextColor text-sm font-medium '>{adminDetails?.email}</p>
                </div>
            </div>
            <hr className="border dark:border-filterDropdownBorder border-StrokeColor" />
            <div className="">
                <ul className="my-4 space-y-2">
                    {!window.location.pathname.includes("/accessdenied")&&<li className="p-2 dark:hover:bg-profileHoverColor hover:bg-menubghover rounded-5">
                      <Link to="/profile/personalInfo" className="cursor-pointer items-center space-x-1.5"  onClick={closePopupHandler}>
                        <span className="icon manageAccount-icon logout-icon cursor-pointer"></span> <span className="!text-subTextColor font-medium text-base">Manage Account</span>
                      </Link>
                    </li>}
                    <li className="p-2 dark:hover:bg-profileHoverColor hover:bg-menubghover rounded-5">
                     <div className="flex justify-center items-center">
                       <button onClick={handleLogout} className="flex space-x-1.5 !w-full !rounded-5 items-center logout-btn-style" >
                         <span className='icon logout cursor-pointer' title="Logout" onClick={handleLogout}></span>
                         <span className="!text-subTextColor font-medium text-base">Logout</span>
                       </button>
                      </div>
                    </li>
                </ul>
                
            </div>
            
            </div>
        )
    }, [])
    return (
            <Popover
                content={profileMenuHandler}
                trigger={["click"]}
                visible={visible}
                onVisibleChange={visiableChangeHandler}
                destroyTooltipOnHide={true}
                placement="bottomLeft"
                overlayClassName="pop-inner p-3.5 border border-headerbborder shadow rounded-5 border dark:!bg-menubghover bg-textWhite header-notifications md:!right-16 !right-3.5 z-[9999]"
                className="bg-transparent"
            >
                <div className='flex gap-1.5 items-center !cursor-pointer justify-end'>
                    <img className='md:w-9 w-8 rounded-full object-cover border border-StrokeColor ' src={adminProfileImg || adminDetails?.imageURL || defaultAvathar} alt="profile img" />
                    <p className='text-sm text-whiteText font-medium max-sm:w-16 overflow-hidden text-ellipsis md:w-11 whitespace-nowrap'>{adminDetails?.userName}</p>
                </div>
            </Popover>
    )
}
export default Profile